import React from 'react';
import './PoliticaDeCookies.css';

const PoliticaDeCookies = () => {
  return (
    <div className="politica-de-cookies">
      <h1>¿Qué son las Cookies?</h1>
      <p>
        Las cookies son pequeños archivos de datos que se reciben en el terminal desde el sitio web visitado y se usan para registrar ciertas interacciones de la navegación en un sitio web almacenando datos que podrán ser actualizados y recuperados. Estos archivos se almacenan en el dispositivo del usuario y contienen datos anónimos que no son perjudiciales para su equipo. Se utilizan para recordar las preferencias del usuario, como el idioma seleccionado, datos de acceso o personalización de la página web o App.
      </p>
      <p>
        Las cookies o dispositivos de almacenamiento han estado tradicionalmente asociados a las páginas web. Sin embargo, estos son actualmente utilizados tanto en páginas web como en otro tipo de plataformas y aplicaciones (por ejemplo, las Apps para teléfonos inteligentes y tablets).
      </p>
      <p>
        Las cookies también pueden ser utilizadas para registrar información anónima sobre cómo un visitante que utiliza un sitio. Por ejemplo, desde qué página web/App ha accedido, o si ha utilizado un "banner" publicitario para llegar.
      </p>
      <h2>¿Por qué utilizamos cookies?</h2>
      <p>
        Utilizamos cookies propias y de terceros para analizar el uso del sitio web y mostrar publicidad con las preferencias sobre la base de un perfil elaborado a partir de los hábitos de navegación del usuario.
      </p>
      <h2>¿Qué uso le damos a los diferentes tipos de cookies?</h2>
      <h3>Según su finalidad:</h3>
      <ul>
        <li><strong>Cookies técnicas:</strong> Son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios.</li>
        <li><strong>Cookies de preferencias o personalización:</strong> Son las que permiten recordar información para que el usuario acceda al servicio con determinadas características.</li>
        <li><strong>Cookies de análisis o medición (analytics):</strong> Son las que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios.</li>
        <li><strong>Cookies publicitarias/de publicidad:</strong> Son las que permiten mostrar publicidad relacionada con el perfil de navegación del usuario.</li>
      </ul>
      <h3>Tipo de cookies según el plazo de tiempo que permanecerán activas:</h3>
      <ul>
        <li><strong>Cookies de sesión:</strong> Son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a una página web/App.</li>
        <li><strong>Cookies persistentes:</strong> Son las que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido.</li>
      </ul>
      <h2>¿Por qué necesitamos su consentimiento explícito para utilizarlas?</h2>
      <p>
        La Guía de la AEPD de julio de 2023 establece que el consentimiento será válido solo cuando sea explícito. El consentimiento del usuario para el uso de cookies debe ser obtenido mediante un "Check" o botón en el que el usuario dé su consentimiento explícito.
      </p>
      <h2>¿Dónde puedo obtener más información?</h2>
      <p>
        Puedes encontrar más información sobre cookies en: <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a> o <a href="https://www.youronlinechoices.eu" target="_blank" rel="noopener noreferrer">www.youronlinechoices.eu</a>.
      </p>
      <p><strong>Actualización: 08/11/2023.</strong></p>
    </div>
  );
};

export default PoliticaDeCookies;
